<template>
  <div class="uk-form-controls uk-grid-small" uk-grid>
    <div class="uk-width-1-3">
      <select v-model="day" class="uk-select">
        <option :value="null">{{ localedDMY[0] }}</option>
        <option v-for="(d, i) in form.days" :value="d" :key="i">
          {{ d }}
        </option>
      </select>
    </div>
    <div class="uk-width-1-3">
      <select v-model="month" class="uk-select">
        <option :value="null">{{ localedDMY[1] }}</option>
        <option v-for="(_, i) in 12" :value="i" :key="i">
          {{ localedMonths[i] }}
        </option>
      </select>
    </div>
    <div class="uk-width-1-3">
      <select v-model="year" class="uk-select">
        <option :value="null">{{ localedDMY[2] }}</option>
        <option v-for="(y, i) in form.yRange" :value="y" :key="i">
          {{ y }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import Calendar       from "@/utils/Calendar";
import { mapGetters } from "vuex";

export default {
  name: "Datepicker",
  props: {
    value: {
      required: false,
      type: Date
    },
  },
  created() {
    this.form.date = this.value;
  },
  mounted() {
    if (!this.value) {
      this.onChange();
    }
  },
  data() {
    return {
      form: new Calendar(),
      months: {
        RU: ["янв.", "февр.", "март", "апр.", "май", "июнь", "июль", "авг.", "сент.", "окт.", "нояб.", "дек."],
        AZ: ["yan", "fev", "mar", "apr", "may", "iyn", "iyl", "avq", "sen", "okt", "noy", "dek"]
      },
      dmy: {
        KY: ["Күн", "Ай", "Жыл"],
        AZ: ["Gün", "Ay", "İl"],
        RU: ["День", "Месяц", "Год"],
        TG: ["Рӯз", "Моҳ", "Сол"],
        UZ: ["Кун", "Ой", "Йил"],
      }
    };
  },
  methods: {
    onChange() {
      this.$emit("input", this.form.date);
    }
  },
  computed: {
    ...mapGetters(["locale"]),
    localedMonths() {
      return this.locale === "az" ? this.months.AZ : this.months.RU;
    },
    localedDMY() {
      const locale = this.dmy[this.locale.toUpperCase()];
      return locale ? locale : this.dmy.RU;
    },
    year: {
      get() {
        return this.form.year;
      },
      set(val) {
        this.form.setYear(val);
        this.onChange();
      }
    },
    month: {
      get() {
        return this.form.month;
      },
      set(val) {
        this.form.setMonth(val);
        this.onChange();
      }
    },
    day: {
      get() {
        return this.form.day;
      },
      set(val) {
        this.form.setDay(val);
        this.onChange();
      }
    }
  }
};
</script>